import { frontendURL } from 'dashboard/helper/URLHelper.js';
import Index from './Index.vue';
import SejaRevenda from './SejaRevenda.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/revenda'),
      name: 'revenda_index',
      component: Index,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/seja-revenda'),
      name: 'seja_revenda',
      component: SejaRevenda,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
